/* ai-recs.js (V3.7 Quick Add Single-Add Fix)
   - Prevents double add (theme form submit + ajax fallback)
   - Prevents duplicate click handlers (render may run more than once)
   - Resolves variant id via /products/{handle}.js when needed
   - Triggers theme cart drawer logic (cart:reload + open drawer)
*/
(function () {
  "use strict";

  var root = document.querySelector("[data-ai-recs]");
  if (!root) return;

  var grid = root.querySelector("[data-ai-recs-grid]");
  var pid = root.getAttribute("data-product-id");
  var limit = Math.max(4, parseInt(root.getAttribute("data-limit") || "8", 10));
  var cacheMin = Math.max(1, parseInt(root.getAttribute("data-cache-min") || "20", 10));
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || "EGP";

  function esc(s) {
    return String(s || "").replace(/[&<>"']/g, function (c) {
      return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c];
    });
  }

  function imgW(url, w) {
    if (!url) return "";
    try {
      var u = new URL(url, window.location.origin);
      // Shopify CDN supports ?width=
      if (!u.searchParams.get("width")) u.searchParams.set("width", String(w));
      return u.toString();
    } catch (e) {
      // fallback for older browsers / relative urls
      if (String(url).indexOf("width=") > -1) return url;
      return String(url) + (String(url).indexOf("?") > -1 ? "&" : "?") + "width=" + String(w);
    }
  }

  function fmtMoneyCents(cents) {
    var v = (Number(cents || 0) / 100);
    try {
      return new Intl.NumberFormat(undefined, { style: "currency", currency: currency }).format(v);
    } catch (e) {
      return v.toFixed(0) + " " + currency;
    }
  }

  function cacheKey() {
    return "ai_recs_v3_7_" + pid + "_" + limit;
  }

  function readCache() {
    try {
      var raw = localStorage.getItem(cacheKey());
      if (!raw) return null;
      var j = JSON.parse(raw);
      if (!j || !j.t || !Array.isArray(j.items)) return null;
      if ((Date.now() - j.t) > cacheMin * 60 * 1000) return null;
      return j.items;
    } catch (e) {
      return null;
    }
  }

  function writeCache(items) {
    try {
      localStorage.setItem(cacheKey(), JSON.stringify({ t: Date.now(), items: items }));
    } catch (e) {}
  }

  async function fetchRecs() {
    var url =
      "/recommendations/products.json?product_id=" +
      encodeURIComponent(pid) +
      "&limit=" +
      encodeURIComponent(limit);
    var res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) throw new Error("recs_failed");
    var data = await res.json();
    var items = (data && data.products) ? data.products : [];
    return items.filter(function (p) { return String(p.id) !== String(pid); });
  }

  async function getVariantIdFromHandle(handle) {
    if (!handle) return null;
    try {
      var res = await fetch("/products/" + encodeURIComponent(handle) + ".js", { credentials: "same-origin" });
      if (!res.ok) return null;
      var p = await res.json();
      if (!p) return null;
      if (p.variants && p.variants.length) {
        var av = p.variants.find(function (v) { return v && v.available; }) || p.variants[0];
        return av ? av.id : null;
      }
      return null;
    } catch (e) {
      return null;
    }
  }

  function getRootPath() {
    try {
      return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : "/";
    } catch (e) {
      return "/";
    }
  }

  function submitViaThemeForm(variantId, qty) {
    var form = document.createElement("form");
    form.method = "post";
    form.action = getRootPath() + "cart/add";
    form.enctype = "application/x-www-form-urlencoded";
    form.style.display = "none";

    // post to hidden iframe to avoid full navigation if theme doesn't intercept
    var frameName = "aiRecsAddFrame";
    var frame = document.getElementById(frameName);
    if (!frame) {
      frame = document.createElement("iframe");
      frame.id = frameName;
      frame.name = frameName;
      frame.style.display = "none";
      document.body.appendChild(frame);
    }
    form.target = frameName;

    var id = document.createElement("input");
    id.type = "hidden";
    id.name = "id";
    id.value = String(variantId);

    var q = document.createElement("input");
    q.type = "hidden";
    q.name = "quantity";
    q.value = String(qty || 1);

    form.appendChild(id);
    form.appendChild(q);
    document.body.appendChild(form);

    try {
      if (form.requestSubmit) form.requestSubmit();
      else form.submit();
    } catch (e) {
      try { form.submit(); } catch (e2) {}
    }

    setTimeout(function () {
      try { form.remove(); } catch (e) {}
    }, 1500);
  }

  async function addViaAjax(variantId, qty) {
    await fetch(getRootPath() + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: parseInt(qty || 1, 10) }]
      })
    });
  }

  async function fetchCartCount() {
    try {
      var res = await fetch(getRootPath() + "cart.js", {
        credentials: "same-origin",
        headers: { "Accept": "application/json" }
      });
      if (!res.ok) return null;
      var c = await res.json();
      return (c && typeof c.item_count === "number") ? c.item_count : null;
    } catch (e) {
      return null;
    }
  }

  function getThemeEvents() {
    try { return (window.ThemeEvents || null); } catch (e) { return null; }
  }

  function getCartComponent() {
    return document.querySelector('[ref="hdt-cart"]') || document.querySelector("hdt-cart-drawer") || null;
  }

  function dispatchCartReload() {
    var evs = getThemeEvents();
    var name = evs && evs.cartReload ? evs.cartReload : "cart:reload";
    try {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { source: "ai-recs" } }));
    } catch (e) {}
  }

  function openCartDrawerLikeTheme() {
    // Mirror theme logic (themeHDN.settings.actionAfterATC)
    var action = null;
    try { action = window.themeHDN && themeHDN.settings && themeHDN.settings.actionAfterATC; } catch (e) {}
    action = action || "open_cart_drawer";

    if (action.indexOf("go_") > -1) {
      try {
        var dest = (action === "go_cart_page") ? "cart" : "checkout";
        window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : "/") + dest;
        return;
      } catch (e) {}
    }

    // open drawer if possible
    var cartEl = getCartComponent();
    if (cartEl && typeof cartEl.open === "function") {
      try { cartEl.open(); } catch (e) {}
    } else {
      // fallback: open dialog
      var dlg = document.getElementById("CartDrawer");
      if (dlg && typeof dlg.showModal === "function" && !dlg.open) {
        try { dlg.showModal(); } catch (e) {}
      }
    }
  }

  function setBtnState(btn, state, text) {
    if (!btn) return;
    if (state === "loading") {
      btn.disabled = true;
      btn.setAttribute("aria-busy", "true");
      btn.textContent = text || "Adding...";
    } else if (state === "done") {
      btn.disabled = false;
      btn.removeAttribute("aria-busy");
      btn.textContent = text || "Added ✓";
      setTimeout(function () { if (btn) btn.textContent = "Quick add"; }, 900);
    } else {
      btn.disabled = false;
      btn.removeAttribute("aria-busy");
      btn.textContent = text || "Quick add";
    }
  }

  function render(items) {
    if (!grid) return;
    if (!items || !items.length) { root.style.display = "none"; return; }

    grid.innerHTML = items.slice(0, limit).map(function (p) {
      var img = "";
      if (p.featured_image) {
        var src360 = imgW(p.featured_image, 360);
        var src240 = imgW(p.featured_image, 240);
        var src480 = imgW(p.featured_image, 480);
        img =
          '<img loading="lazy" decoding="async" ' +
          'src="' + esc(src360) + '" ' +
          'srcset="' + esc(src240) + ' 240w, ' + esc(src360) + ' 360w, ' + esc(src480) + ' 480w" ' +
          'sizes="(max-width: 768px) 45vw, 220px" ' +
          'alt="' + esc(p.title) + '">';
      }
      var handle = p.handle || "";
      var vid = "";
      try { if (p.variants && p.variants[0] && p.variants[0].id) vid = String(p.variants[0].id); } catch (e) {}

      return ''
        + '<div class="ai-recs__card">'
        + '  <a class="ai-recs__link" href="' + esc(p.url) + '">'
        + '    <div class="ai-recs__img">' + img + '</div>'
        + '    <div class="ai-recs__meta">'
        + '      <div class="ai-recs__name">' + esc(p.title) + '</div>'
        + '      <div class="ai-recs__row">'
        + '        <div class="ai-recs__price">' + esc(fmtMoneyCents(p.price)) + '</div>'
        + '        <span class="ai-recs__badge">Smart pick</span>'
        + '      </div>'
        + '    </div>'
        + '  </a>'
        + '  <button class="ai-recs__add" type="button" data-ai-add data-ai-vid="' + esc(vid) + '" data-ai-handle="' + esc(handle) + '">Quick add</button>'
        + '</div>';
    }).join("");

    // ✅ prevent multiple bindings if render is called again
    if (grid.__aiRecsBound) return;
    grid.__aiRecsBound = true;

    grid.addEventListener("click", async function (e) {
      var btn = e.target && e.target.closest ? e.target.closest("[data-ai-add]") : null;
      if (!btn) return;

      e.preventDefault();
      if (btn.disabled) return;

      setBtnState(btn, "loading");

      try {
        var vid = btn.getAttribute("data-ai-vid");
        var handle = btn.getAttribute("data-ai-handle");
        var variantId = vid ? parseInt(vid, 10) : null;
        if (!variantId && handle) variantId = await getVariantIdFromHandle(handle);
        if (!variantId) throw new Error("no_variant");

        // 1) Try theme-like submit first
        var beforeCount = await fetchCartCount();
        submitViaThemeForm(variantId, 1);

        // 2) Fallback ONLY if cart did not change (prevents adding twice)
        setTimeout(async function () {
          try {
            var afterCount = await fetchCartCount();

            // If theme already added the item, don't run fallback
            if (beforeCount !== null && afterCount !== null && afterCount > beforeCount) {
              dispatchCartReload();
              openCartDrawerLikeTheme();
              return;
            }

            // Otherwise fallback to AJAX add
            await addViaAjax(variantId, 1);
            dispatchCartReload();
            openCartDrawerLikeTheme();
          } catch (e2) {}
        }, 450);

        setBtnState(btn, "done", "Added ✓");
      } catch (err) {
        setBtnState(btn, "idle", "Try again");
      }
    });
  }

  async function run() {
    var cached = readCache();
    if (cached) { render(cached); return; }
    var items = await fetchRecs();
    // stable-ish shuffle
    items.sort(function (a, b) { return ((b.id % 7) - (a.id % 7)); });
    writeCache(items);
    render(items);
  }

  // Lazy load
  
  // V11.3.3: Eager mode for below-the-fold on product pages
  // If element has data-ai-eager="1", start fetching on DOMContentLoaded/idle
  var eager = root && root.getAttribute && root.getAttribute("data-ai-eager") === "1";
  if (eager) {
    var startEager = function () {
      run().catch(function () { root.style.display = "none"; });
    };
    var kick = function () {
      if ("requestIdleCallback" in window) requestIdleCallback(startEager, { timeout: 800 });
      else setTimeout(startEager, 0);
    };
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", kick, { once: true });
    else kick();
    return;
  }

var io = new IntersectionObserver(function (entries) {
    var en = entries && entries[0];
    if (!en || !en.isIntersecting) return;
    io.disconnect();

    var start = function () {
      run().catch(function () { root.style.display = "none"; });
    };

    if ("requestIdleCallback" in window) requestIdleCallback(start, { timeout: 600 });
    else setTimeout(start, 0);
  }, { rootMargin: "1500px 0px" });

  io.observe(root);
})();